/**
 * A requester's client(s), as one short label for a dropdown row.
 *
 * A user can belong to several clients — outsourced bookkeepers, partner MSPs,
 * AIM staff attached to the clients they look after. The API used to expose a
 * single `company`, picked arbitrarily when there were several, so the dropdown
 * could name the wrong client. It now also sends `companies` with the full list;
 * `company` is kept for callers that genuinely want just one.
 *
 * Long lists are truncated so one many-client user can't push the row off screen.
 * Pass `title: requesterCompanyTitle(req)` alongside for the full list on hover.
 */
const MAX_SHOWN = 2;

function companyList(req) {
  if (Array.isArray(req?.companies) && req.companies.length) {
    return req.companies.map((c) => c?.companyname).filter(Boolean);
  }
  return req?.company?.companyname ? [req.company.companyname] : [];
}

export function requesterCompanyLabel(req) {
  const names = companyList(req);
  if (!names.length) return '';
  if (names.length <= MAX_SHOWN) return names.join(', ');
  return `${names.slice(0, MAX_SHOWN).join(', ')} +${names.length - MAX_SHOWN} more`;
}

export function requesterCompanyTitle(req) {
  return companyList(req).join(', ');
}
